export default __webpack_public_path__ + "static/63-8b73267640eb9e025ec4cf93fe81efe9.png";